import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationService from '../services/navigationService';

const NavigationProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();

  useEffect(() => {
    NavigationService.setNavigate(navigate);
  }, [navigate]);

  return <>{children}</>;
};

export default NavigationProvider; 